import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ConfigService } from '../config.service';
import { AESService } from '../encryption/aes.service';
// const httpOptions = {
//   headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem('accesstoken') })
// };

@Injectable(
  //   {
  //   providedIn: 'root'
  // }
)
export class ListUserService {
  constructor(public http: HttpClient, public config: ConfigService,private Cryptography : AESService) {
  }
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.Cryptography.getItem('accesstoken',true) })
  };
  ListUser(): Observable<any> {
    return this.http.get(this.config.baseURL + '/user/list', this.httpOptions)
      .map((res) => { return res }

      );
  }
  ActivateUser(user: any): Observable<any> {
    return this.http.post<any>(this.config.baseURL + '/user/canactive', user, this.httpOptions)
      .map((res) => { return res }

      );
  }
  UpdateUser(user: any): Observable<any> {
    return this.http.post<any>(this.config.baseURL + '/user/updateuser', user, this.httpOptions)
      .map((res) => { return res }

      );
  }
  getUserbyId(user: any): Observable<any> {
    return this.http.post<any>(this.config.baseURL + '/user/getuserbyid',user, this.httpOptions).map((res) => { return res });
  }

  DeleteUser(user: any): Observable<any> {
    return this.http.post<any>(this.config.baseURL + '/user/deleteuser', user, this.httpOptions)
      .map((res) => { return res }

      );
  }
}
